import { fromIsoDate, isoWeekDates, isoWeekKey, isoWeekParts, isoWeekdayIndex, shiftIsoWeek, toIsoDate, } from "./isoWeek";
export const DEFAULT_MEAL_SLOTS = [
    { id: "frukost", label: "Frukost · 07:30-09:00" },
    { id: "lunch", label: "Lunch · 12:00-13:00" },
    { id: "middag", label: "Middag · 17:30-18:30" },
    { id: "kvallsfika", label: "Kvällsfika · 20:00" },
];
export function sortWeeks(weeks) {
    return [...weeks].sort((a, b) => isoWeekKey(a.year, a.week) - isoWeekKey(b.year, b.week));
}
export function findWeek(weeks, year, week) {
    return (weeks !== null && weeks !== void 0 ? weeks : []).find((w) => w.year === year && w.week === week);
}
export function upsertWeek(weeks, next) {
    const rest = (weeks !== null && weeks !== void 0 ? weeks : []).filter((w) => !(w.year === next.year && w.week === next.week));
    const pruned = pruneWeek(next);
    return sortWeeks(pruned ? [...rest, pruned] : rest);
}
export function pruneWeek(week) {
    const days = week.days
        .map((d) => ({ ...d, meals: d.meals.filter(mealHasContent) }))
        .filter((d) => d.meals.length > 0);
    return days.length ? { ...week, days } : null;
}
export function mealHasContent(meal) {
    return localizedHasText(meal.body) || localizedHasText(meal.note);
}
export function localizedHasText(v) {
    if (v == null)
        return false;
    if (typeof v === "string")
        return v.trim().length > 0;
    return Object.values(v).some((s) => typeof s === "string" && s.trim());
}
export function countMeals(week) {
    if (!week)
        return 0;
    return week.days.reduce((n, d) => n + d.meals.filter(mealHasContent).length, 0);
}
export function countFilledDays(week) {
    if (!week)
        return 0;
    return week.days.filter((d) => d.meals.some(mealHasContent)).length;
}
export function blankWeek(year, week, slots = DEFAULT_MEAL_SLOTS) {
    return {
        year,
        week,
        days: isoWeekDates(year, week).map((date) => ({
            date,
            meals: slots.map((s) => ({ id: s.id, label: s.label, body: "" })),
        })),
    };
}
export function copyWeekTo(source, year, week) {
    const targetDates = isoWeekDates(year, week);
    const byIndex = new Map();
    for (const day of source.days) {
        const parsed = fromIsoDate(day.date);
        if (!parsed)
            continue;
        byIndex.set(isoWeekdayIndex(parsed), day);
    }
    return {
        year,
        week,
        days: targetDates.map((date, i) => {
            var _a, _b;
            return ({
                date,
                meals: ((_b = (_a = byIndex.get(i)) === null || _a === void 0 ? void 0 : _a.meals) !== null && _b !== void 0 ? _b : []).map((m) => ({ ...m })),
            });
        }),
    };
}
export function findDay(weeks, date) {
    var _a;
    const parsed = fromIsoDate(date);
    if (!parsed)
        return undefined;
    const { year, week } = isoWeekParts(parsed);
    return (_a = findWeek(weeks, year, week)) === null || _a === void 0 ? void 0 : _a.days.find((d) => d.date === date);
}
export function currentWeek(weeks, now) {
    const list = sortWeeks((weeks !== null && weeks !== void 0 ? weeks : []).filter((w) => countMeals(w) > 0));
    if (!list.length)
        return undefined;
    const { year, week } = isoWeekParts(now);
    const nowKey = isoWeekKey(year, week);
    const exact = list.find((w) => isoWeekKey(w.year, w.week) === nowKey);
    if (exact)
        return exact;
    return list.find((w) => isoWeekKey(w.year, w.week) > nowKey);
}
export function todaysMeals(weeks, now) {
    var _a;
    const day = findDay(weeks, toIsoDate(now));
    const meals = (_a = day === null || day === void 0 ? void 0 : day.meals.filter(mealHasContent)) !== null && _a !== void 0 ? _a : [];
    return meals.length ? meals : undefined;
}
export function mergeWeeks(base, incoming) {
    let out = [...(base !== null && base !== void 0 ? base : [])];
    for (const week of incoming) {
        const existing = findWeek(out, week.year, week.week);
        if (!existing) {
            out = upsertWeek(out, week);
            continue;
        }
        const byDate = new Map(existing.days.map((d) => [d.date, d]));
        for (const day of week.days)
            byDate.set(day.date, day);
        out = upsertWeek(out, {
            ...existing,
            days: [...byDate.values()].sort((a, b) => a.date.localeCompare(b.date)),
        });
    }
    return out;
}
export function pruneOldWeeks(weeks, now, keepWeeks = 8) {
    const { year, week } = isoWeekParts(now);
    const back = shiftIsoWeek(year, week, -keepWeeks);
    const cutoff = isoWeekKey(back.year, back.week);
    return sortWeeks((weeks !== null && weeks !== void 0 ? weeks : []).filter((w) => isoWeekKey(w.year, w.week) >= cutoff));
}
